import React, { ReactNode } from 'react';
import { Dropdown, Menu, message } from 'antd';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import { IconArrowDown } from '../Icons';

import './NoteCard.less';

export type NoteCardType = {
  title: ReactNode;
  dropdownData?: { name: string; src: string }[];
  description?: string;
  name?: string;
  date?: string;
  dropdownText?: ReactNode;
  onItemClick?: React.MouseEventHandler<HTMLDivElement>;
};
const NoteCard: React.FC<NoteCardType> = ({
  title,
  description,
  dropdownData = [],
  date,
  name,
  dropdownText,
  onItemClick = () => {},
}) => {
  const classNames: String[] = ['t-note-card-container'];

  const menu = (
    <Menu>
      {dropdownData.map((item, index) => {
        return (
          <Menu.Item key={index}>
            <span key={index} className={'t-note-files'}>
              <a href={item.src} target="_blank" rel="noopener noreferrer">
                {item.name}
              </a>
            </span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <div className={classNames.join(' ')} onClick={onItemClick}>
      <Wrapper mb={1}>
        <Text rows={2} bold level={1}>
          {title}
        </Text>
      </Wrapper>
      <Wrapper mb={1}>
        <Text readMore rows={3} level={3}>
          {description}
        </Text>
      </Wrapper>
      <Wrapper mb={1}>
        {!!dropdownData.length && (
          <Dropdown overlay={menu} overlayClassName={'t-note-dropdown'}>
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              {dropdownText}
              <IconArrowDown />
            </a>
          </Dropdown>
        )}
      </Wrapper>
      <Wrapper
        display="flex"
        justifyContent="space-between"
        alignItems={'center'}
      >
        <Wrapper mr={2}>
          <Text rows={1} textColor="dark-50" level={3}>
            {name}
          </Text>
        </Wrapper>

        <Text rows={1} textColor="dark-50" level={3}>
          {date}
        </Text>
      </Wrapper>
    </div>
  );
};

export default NoteCard;
